import { PaymentDetailFragment } from 'generated/resources/graphql'

import MoneyWithCurrency from 'modules/core/lib/money'

import { Payment as DataTablePayment } from '../components/PaymentsDataTable/types'

export const lastPaymentExecution = (payment: DataTablePayment) => {
  return payment.paymentExecutions[payment.paymentExecutions.length - 1]
}
export const lastPaymentExecutionfromPaymentDetail = (payment: PaymentDetailFragment) => {
  return payment.paymentExecutions[payment.paymentExecutions.length - 1]
}

export const formattedAmount = ({
  amountCents,
  currency,
  locale,
  emptyValue = '',
}: {
  amountCents?: number | null
  currency?: string | null
  locale: string
  emptyValue?: string
}): string => {
  const upperCaseCurrency = currency?.toUpperCase()
  if (amountCents == null) {
    return emptyValue
  }
  return MoneyWithCurrency({
    amount: Math.round(amountCents || 0),
    currency: upperCaseCurrency,
    locale,
    emptyValue,
  })
}
